import { render, staticRenderFns } from "./idea.vue?vue&type=template&id=0beb2b66&scoped=true&"
var script = {}
import style0 from "./idea.vue?vue&type=style&index=0&id=0beb2b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb2b66",
  null
  
)

export default component.exports